import React from 'react';

export const MU = () => {
	return (
		<svg
			width='20'
			height='15'
			viewBox='0 0 20 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_11534_5841)'>
				<mask
					id='mask0_11534_5841'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='20'
					height='15'
				>
					<rect width='20' height='15' fill='white' />
				</mask>
				<g mask='url(#mask0_11534_5841)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0V15H20V0H0Z'
						fill='#579D20'
					/>
					<mask
						id='mask1_11534_5841'
						style={{ maskType: 'luminance' }}
						maskUnits='userSpaceOnUse'
						x='0'
						y='0'
						width='20'
						height='15'
					>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 0V15H20V0H0Z'
							fill='white'
						/>
					</mask>
					<g mask='url(#mask1_11534_5841)'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 7.5V11.25H20V7.5H0Z'
							fill='#FECA00'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 3.75V7.5H20V3.75H0Z'
							fill='#3D58DB'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 0V3.75H20V0H0Z'
							fill='#E11C1B'
						/>
					</g>
				</g>
			</g>
			<rect
				x='0.5'
				y='0.5'
				width='19'
				height='14'
				rx='1'
				stroke='black'
				strokeOpacity='0.1'
			/>
			<defs>
				<clipPath id='clip0_11534_5841'>
					<rect width='20' height='15' rx='1.5' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
